import { createContext } from 'react';

/** Sample games render the live UI without reading or changing real game data. */
export const BoxPreviewContext = createContext(false);
